import React from 'react';
import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import {BrowserRouter} from 'react-router-dom'
import Checkout from './components/Checkout';
import Thanks from './components/Thanks'

export const config = {
  endpoint:`https://qkart-frontend-nameer.herokuapp.com/api/v1`
};

function App() {
  return (    
  <React.StrictMode>
    <BrowserRouter>
   

      <Switch>
      <ThemeProvider theme={theme}>
          
          <div className="App">
              
              <Route path="/login" component={Login} />
              <Route path="/register" component={Register} />
              <Route exact path="/checkout"> 
                <Checkout/>
              </Route> 
              <Route exact path="/thanks"> 
                <Thanks/>
              </Route> 
              <Route exact path="/" component={Products} />
          </div>
          </ThemeProvider>
        </Switch>

   

    </BrowserRouter>

 </React.StrictMode>

  );
}

export default App;
